import { createSvgIcon } from '@mui/material';

export const TemplateFolderSvg = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M9.1 5H3.4C2.355 5 1.5095 5.84375 1.5095 6.875L1.5 18.125C1.5 19.1562 2.355 20 3.4 20H18.6C19.645 20 20.5 19.1562 20.5 18.125V8.75C20.5 7.71875 19.645 6.875 18.6 6.875H11L9.1 5Z"
      fill="#377771"
    />
    <rect
      x="3"
      y="7"
      width="16"
      height="12"
      rx="0.5"
      fill="white"
      stroke="#CACCD3"
      strokeWidth="0.7"
    />
    <rect
      x="4.3999"
      y="8.7998"
      width="15"
      height="11"
      rx="0.5"
      fill="white"
      stroke="#CACCD3"
      strokeWidth="0.7"
    />
    <path
      d="M19.6449 19.9999H3.22442C2.87451 19.9999 2.63282 19.6498 2.75692 19.3226L5.53448 12L5.53448 12C5.53454 11.9998 6.29316 10.0002 7.81034 10C9.32252 9.99983 20.905 10.1656 20.9824 10.1667L20.9857 10.1667C21.0597 10.1676 22.5 10.2009 22.5 11.5C22.5 12.6603 20.6067 18.2383 20.1154 19.6663C20.0462 19.8674 19.8575 19.9999 19.6449 19.9999Z"
      fill="#377771"
    />
  </svg>,
  'TemplateFolder',
);
